export class UserLoginResponse {
  token: string;
  dataAtivacao: Date;
  dataExclusaoPrevista: Date;
  dataFimAvaliacao: Date;
  problemaPagamento: boolean;
  erro: string;
  cadastroAtivo: boolean;

  constructor(userLoginResponse?: UserLoginResponse) {
    this.token = userLoginResponse?.token ?? "";
    this.dataAtivacao = userLoginResponse?.dataAtivacao ?? new Date();
    this.dataExclusaoPrevista =
      userLoginResponse?.dataExclusaoPrevista ?? new Date();
    this.dataFimAvaliacao = userLoginResponse?.dataFimAvaliacao ?? new Date();
    this.problemaPagamento = userLoginResponse?.problemaPagamento ?? false;
    this.erro = userLoginResponse?.erro ?? "";
    this.cadastroAtivo = userLoginResponse?.cadastroAtivo ?? false;
  }
}
